import { Link, useMatches } from '@tanstack/react-router';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/shared/ui/breadcrumb';
import { hasCrumb } from '@/shared/utils';

export const AppBreadcrumbs = () => {
  const matches = useMatches();
  const intl = useIntl();

  const breadcrumbItems = matches
    .filter(
      (match) => match.loaderData && hasCrumb(match.loaderData) && match.loaderData.crumb,
    )
    .map(({ pathname, loaderData }) => ({
      href: pathname,
      label: (loaderData as { crumb: string }).crumb,
    }));

  const currentPage = breadcrumbItems.pop();

  if (currentPage?.href === '/' || !currentPage) {
    return null;
  }

  return (
    <Breadcrumb className="py-5">
      <BreadcrumbList>
        {breadcrumbItems.map((item) => (
          <Fragment key={item.label}>
            <BreadcrumbItem className="text-base">
              <BreadcrumbLink asChild>
                <Link to={item.href}>
                  {intl.formatMessage({ id: item.label, defaultMessage: item.label })}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbSeparator />
          </Fragment>
        ))}

        <BreadcrumbItem className="text-base">
          <BreadcrumbPage>
            {intl.formatMessage({
              id: currentPage.label,
              defaultMessage: currentPage.label,
            })}
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
};
